export default (locale) => ({
	name: 'localization-request',
	req: (payload) => {
		Object.assign(payload.req.headers, {
			'Accept-Language': locale,
		});

		return payload;
	},
});
